// 3D Model constants for DIP/PDIP packages (through-hole)
export const dipPinMarkerSize = 0.0004; // Larger for through-hole packages
export const dipPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 450;
export const dipPinMarkerOffsetZ = 0.000001;
export const dipPinMarkerSegments = 32;
// DIP-specific constants - per JEDEC MS-001 lead dimensions
// Lead width: 0.018-0.022 inches (0.46-0.56mm), using 0.5mm nominal
// Lead thickness: 0.008-0.014 inches (0.20-0.36mm), using 0.25mm nominal
export const dipPinWidth = 0.0005; // Lead width (0.5mm) - must fit through ~0.8mm hole
export const dipPinThickness = 0.00025; // Lead thickness (0.25mm)
export const dipPinHeight = 0.003; // Height of pin below board (3mm)
export const dipPinShoulderLength = 0.0005; // Length of horizontal shoulder from body (0.5mm)
export const dipNotchRadius = 0.0008; // Radius of notch at top center (0.8mm)
// Per JEDEC MS-001, body width (E1) is typically ~1.27mm (50 mil) narrower than lead span (E)
// For 0.3" DIP: lead span = 7.62mm, body width = ~6.35mm (0.25")
// For 0.6" DIP: lead span = 15.24mm, body width = ~13.97mm (0.55")
export const dipBodyWidthReduction = 0.00127; // 1.27mm reduction from row spacing to get body width
// Body length end margin - extra length beyond the end pins on each side
export const dipBodyEndMargin = 0.00127; // 1.27mm margin on each end
//# sourceMappingURL=dipConstants.js.map